import React, { Fragment } from 'react'
import styled from '@emotion/styled'
import flattenChildren from 'react-keyed-flatten-children'

import { Box } from '../Box/Box'
import { Icon } from '../Icon/Icon'

export interface BreadcrumbsProps extends BaseProps {
  children: React.ReactNode
}

export const Breadcrumbs: React.FC<BreadcrumbsProps> = ({ children }) => {
  const crumbs = flattenChildren(children)
  return (
    <Box display="flex" alignItems="center">
      {crumbs.map((crumb, index) => (
        <Fragment key={index}>
          {index !== 0 && (
            <Box paddingX="xs">
              <Icon name="arrow" size="xs" rotate={270} />
            </Box>
          )}
          {crumb}
        </Fragment>
      ))}
    </Box>
  )
}

export const Crumb = styled.p`
  font-size: var(--font-size--base);
  font-weight: 400;
  line-height: 18px;

  &:last-of-type {
    font-size: var(--font-size--base);
    font-weight: 700;
    color: var(--button-text--secondary);

    a {
      color: var(--button-text--secondary);
    }

    :after {
      content: '';
      padding: 0;
    }
  }

  a {
    color: var(--colors-neutral);
    text-decoration: none;

    &:hover,
    &:active {
      text-decoration: underline;
    }
  }
`
